import React from "react";
import styled from "styled-components";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { Link } from "react-router-dom";

// Import real images
import Cleaner from "../../assets/img/Services/cleaner2.jpg";
import Driver from "../../assets/img/Services/driver1.jpg";
import Nanny from "../../assets/img/Services/nanny2.jpeg";
import Cook from "../../assets/img/Services/cook2.jpeg";

const services = [
  {
    title: "Cooking",
    image: Cook,
    description: "Home-cooked meals tailored to your family’s taste and health."
  },
  {
    title: "Nanny",
    image: Nanny,
    description: "Trained nannies for safe and compassionate child care."
  },
  {
    title: "Driver",
    image: Driver,
    description: "Professional drivers for school, office or errands."
  },
  {
    title: "Cleaner",
    image: Cleaner,
    description: "Keep your space spotless with our experienced cleaners."
  },
];

export default function ServicesSection() {
  return (
    <Wrapper>
      <Container>
        <Title>Get Services Now</Title>
        <Subtitle>
          Enjoy top-quality home care with our reliable and professional maids.
          Our services ensure your home is always clean and well-maintained in
          Karachi, Lahore, and Islamabad.
        </Subtitle>

        <CardsWrapper>
          {services.map((service, index) => (
            <Link to="/services">
            <Card key={index}>
              <ImageWrapper>
                <LazyLoadImage
                  src={service.image}
                  alt={service.title}
                  effect="blur"
                  style={{
                    width: "130px",
                    height: "130px",
                    objectFit: "cover",
                    borderRadius: "50%",
                    border: "3px solid #e0f7f5",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                  }}
                />
              </ImageWrapper>
              <CardTitle>{service.title}</CardTitle>
              <CardDesc>{service.description}</CardDesc>
            </Card>
            </Link>
          ))}
        </CardsWrapper>

        <ButtonWrapper>
          <StyledLink to="/services">See All Services</StyledLink>
        </ButtonWrapper>
      </Container>
    </Wrapper>
  );
}

// Styled Components
const Wrapper = styled.section`
  background-color:rgb(255, 255, 255);
  padding: 60px 20px;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const Title = styled.h2`
  font-size: 40px;
  font-weight: 800;
  text-align: center;
  color: #003b57;
`;

const Subtitle = styled.p`
  font-size: 18px;
  text-align: center;
  color: #333;
  max-width: 700px;
  margin: 20px auto 40px auto;
`;

const CardsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 30px;
  justify-items: center;
`;

const Card = styled.div`
  background:rgb(48, 237, 190);
  border-radius: 20px;
  padding: 30px 20px;
  width: 100%;
  max-width: 260px;
  text-align: center;
  transition: 0.3s ease;
  &:hover {
    background: #c6f4e7;
    transform: translateY(-5px);
  }
`;

const ImageWrapper = styled.div`
  margin-bottom: 20px;
`;

const CardTitle = styled.h3`
  font-size: 22px;
  font-weight: 700;
  color: #004b63;
  margin-bottom: 10px;
`;

const CardDesc = styled.p`
  font-size: 14px;
  color: #444;
  margin-bottom: 15px;
  line-height: 1.4;
  min-height: 40px;
`;

const ExpandButton = styled.div`
  font-size: 24px;
  background: #dffff9;
  color: #009688;
  border-radius: 50px;
  width: 40px;
  height: 40px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ButtonWrapper = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: center;
`;

const StyledLink = styled(Link)`
  background-color: #009688;
  color: white;
  padding: 12px 30px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: bold;
  transition: background 0.3s ease;
  &:hover {
    background-color: #00796b;
  }
`;
